import { render, staticRenderFns } from "./dashboardOrcamentoOrgao.vue?vue&type=template&id=7a420ba6&"
import script from "./dashboardOrcamentoOrgao.vue?vue&type=script&lang=js&"
export * from "./dashboardOrcamentoOrgao.vue?vue&type=script&lang=js&"
import style0 from "./dashboardOrcamentoOrgao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports